module.exports = __webpack_public_path__ + "img/1-full-sm.592e3d8e.jpg";